/**
 * Custom Accordion Component for FAQ Section
 * 
 * Features:
 * - Smooth animations for expand/collapse
 * - Plus/minus toggle icon
 * - Accessibility support with ARIA attributes
 * - Auto-height calculations for content
 */

class AccordionComponent {
  constructor() {
    this.accordionButtons = document.querySelectorAll('.accordion__button');
    this.init();
  }

  init() {
    if (!this.accordionButtons.length) return;
    
    this.accordionButtons.forEach(button => {
      // Set initial state
      const content = document.getElementById(button.getAttribute('aria-controls'));
      button.setAttribute('aria-expanded', 'false');
      
      // Add click event listener
      button.addEventListener('click', () => this.toggleAccordion(button, content));
    });
  }

  toggleAccordion(button, content) {
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    
    // Close all accordions first if we're opening a new one
    if (!isExpanded) {
      // this.closeAllAccordions();
    }
    
    // Toggle the clicked accordion
    if (isExpanded) {
      this.closeAccordion(button, content);
    } else {
      this.openAccordion(button, content);
    }
  }

  openAccordion(button, content) {
    // Update button state
    button.setAttribute('aria-expanded', 'true');
    
    // Get the scroll height to use for animation
    const contentInner = content.querySelector('.accordion__content-inner');
    const contentHeight = contentInner.getBoundingClientRect().height;
    
    // Animate opening
    content.classList.add('active');
    content.style.height = contentHeight + 'px';
    
    // Remove fixed height after animation completes for flexible content
    setTimeout(() => {
      if (button.getAttribute('aria-expanded') === 'true') {
        content.style.height = 'auto';
      }
    }, 500); // Match this with CSS transition duration
  }

  closeAccordion(button, content) {
    // Update button state
    button.setAttribute('aria-expanded', 'false');
    
    // Set fixed height before animating
    const contentHeight = content.getBoundingClientRect().height;
    content.style.height = contentHeight + 'px';
    
    // Trigger reflow to ensure the height is applied before changing it
    content.offsetHeight; // eslint-disable-line no-unused-expressions
    
    // Animate closing
    content.style.height = '0';
    content.classList.remove('active');
  }

  closeAllAccordions() {
    this.accordionButtons.forEach(button => {
      const content = document.getElementById(button.getAttribute('aria-controls'));
      if (button.getAttribute('aria-expanded') === 'true') {
        this.closeAccordion(button, content);
      }
    });
  }
}

// Initialize on document ready
document.addEventListener('DOMContentLoaded', () => {
  new AccordionComponent();
});

// Re-initialize on section load for theme editor
document.addEventListener('shopify:section:load', (event) => {
  if (event.detail.sectionId.includes('collapsible-faq')) {
    new AccordionComponent();
  }
});